(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4439],{

/***/ 66171:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/work-hours-calculator",
      function () {
        return __webpack_require__(8772);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 8772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ work_hours_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Tools/TimeCardCalculator/Day.jsx


const Day = (param)=>{
    let { day , onHandleData , resetBtn  } = param;
    // const [startTime, setStartTime] = useState("");
    // const [startAMPM, setStartAMPM] = useState("am");
    // const [endTime, setEndTime] = useState("");
    // const [endAMPM, setEndAMPM] = useState("pm");
    // const [breakTime, setBreakTime] = useState("00:00");
    // const [result, setResult] = useState("")
    const [hours, setHours] = (0,react.useState)({
        startTime: "",
        startAMPM: "am",
        endTime: "",
        endAMPM: "pm",
        breakTime: "00:00",
        result: ""
    });
    // handle input changes 
    const handleChange = (tags)=>(event)=>{
            const inputValue = event.target.value;
            let newValue = inputValue;
            if (inputValue.includes(":")) {
                newValue = inputValue.replace(/:/g, "");
            }
            if (newValue.length > 2) {
                newValue = "".concat(newValue.slice(0, 2), ":").concat(newValue.slice(2));
            }
            if (newValue.length >= 2 && newValue.charAt(0) > 1) {
                newValue = "0".concat(newValue);
            }
            if (newValue.length >= 3 && newValue.slice(0, 2) > 12) {
                newValue = "12".concat(newValue.slice(2));
            }
            if (newValue.length === 5 && newValue.slice(3) > 59) {
                newValue = "".concat(newValue.slice(0, 3), "00");
            }
            if (tags === "start-time") {
                setHours((prev)=>({
                        ...prev,
                        startTime: newValue
                    }));
            }
            if (tags === "end-time") {
                setHours((prev)=>({
                        ...prev,
                        endTime: newValue
                    }));
            }
            if (tags === "break-time") {
                setHours((prev)=>({
                        ...prev,
                        breakTime: newValue
                    }));
            }
        };
    (0,react.useEffect)(()=>{
        var _hours_startTime_split, _hours_startTime, _hours_endTime_split, _hours_endTime, _hours_breakTime_split, _hours_breakTime;
        const [startHours, startMinutes] = (_hours_startTime_split = hours === null || hours === void 0 ? void 0 : (_hours_startTime = hours.startTime) === null || _hours_startTime === void 0 ? void 0 : _hours_startTime.split(":")) === null || _hours_startTime_split === void 0 ? void 0 : _hours_startTime_split.map(Number);
        const [endHours, endMinutes] = (_hours_endTime_split = hours === null || hours === void 0 ? void 0 : (_hours_endTime = hours.endTime) === null || _hours_endTime === void 0 ? void 0 : _hours_endTime.split(":")) === null || _hours_endTime_split === void 0 ? void 0 : _hours_endTime_split.map(Number);
        const [breakHours, breakMinutes] = (_hours_breakTime_split = hours === null || hours === void 0 ? void 0 : (_hours_breakTime = hours.breakTime) === null || _hours_breakTime === void 0 ? void 0 : _hours_breakTime.split(":")) === null || _hours_breakTime_split === void 0 ? void 0 : _hours_breakTime_split.map(Number);
        let hours_var = endHours - startHours;
        let minutes = endMinutes - startMinutes;
        if (hours.startAMPM === "pm") hours_var += 12;
        if (hours.endAMPM === "pm") hours_var += 12;
        if (minutes < 0) {
            minutes += 60;
            hours_var -= 1;
        }
        const totalMinutes = hours_var * 60 + minutes - (breakHours * 60 + breakMinutes);
        const totalHours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        // console.log(totalHours, " ", remainingMinutes)
        const formattedResult = "".concat(totalHours, ":").concat(remainingMinutes.toString().padStart(2, "0"));
        setHours((prev)=>({
                ...prev,
                result: formattedResult
            }));
        // setResult(formattedResult)
        if (formattedResult !== "NaN:NaN") {
            onHandleData(day, formattedResult);
        } else {
            onHandleData(day, "00:00");
        }
    }, [
        hours.startTime,
        hours.startAMPM,
        hours.endTime,
        hours.endAMPM,
        hours.breakTime,
        day
    ]);
    (0,react.useEffect)(()=>{
        if (resetBtn === true) {
            setHours({
                startTime: "",
                statrAMPM: "am",
                endTime: "",
                endAMPM: "pm",
                breakTime: "",
                result: "00:00"
            });
        }
    }, [
        resetBtn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: "flex justify-between items-center text-[13px] font-medium text-gray-500 w-full pb-[10px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[56px] text-gray-700",
                children: day
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row w-[154px] justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        style: {
                            width: "65px",
                            outline: "none"
                        },
                        className: "rounded-md border text-gray-500 outline-none py-2 px-3 w-[65px] mr-2",
                        id: "start-time",
                        name: "start-time",
                        type: "text",
                        placeholder: "00:00",
                        maxLength: 5,
                        required: true,
                        value: hours.startTime,
                        onChange: handleChange("start-time")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        style: {
                            width: "45px",
                            outline: "none"
                        },
                        className: "border outline-none rounded-md w-[45px]",
                        id: "start-ampm",
                        name: "start-ampm",
                        required: true,
                        value: hours.startAMPM,
                        onChange: (e)=>setHours((prev)=>({
                                    ...prev,
                                    startAMPM: e.target.value
                                })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "am",
                                children: "AM"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "pm",
                                children: "PM"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row w-[154px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        style: {
                            width: "65px",
                            outline: "none"
                        },
                        className: "border text-gray-400 outline-none rounded-md py-2 px-3 w-[65px] mr-2",
                        id: "end-time",
                        name: "end-time",
                        type: "text",
                        placeholder: "00:00",
                        maxLength: 5,
                        required: true,
                        value: hours.endTime,
                        onChange: handleChange("end-time")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        style: {
                            width: "45px",
                            outline: "none"
                        },
                        className: "border outline-none rounded-md w-[45px]",
                        id: "end-ampm",
                        name: "end-ampm",
                        required: true,
                        value: hours.endAMPM,
                        onChange: (e)=>setHours((prev)=>({
                                    ...prev,
                                    endAMPM: e.target.value
                                })),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "pm",
                                children: "PM"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "am",
                                children: "AM"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[91px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    style: {
                        width: "65px",
                        outline: "none"
                    },
                    className: "border rounded-md py-2 px-3 w-[65px] mr-2",
                    id: "start-time",
                    name: "break-time",
                    type: "text",
                    placeholder: "00:00",
                    maxLength: 5,
                    required: true,
                    value: hours.breakTime,
                    onChange: handleChange("break-time")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[67px] flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "",
                    children: hours.result === "NaN:NaN" ? "00:00" : hours.result
                })
            })
        ]
    });
};
/* harmony default export */ var TimeCardCalculator_Day = (Day);

// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Tools/TimeCardCalculator/TimeCalc.jsx





const days = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const TimeCalc = ()=>{
    const [data, setData] = (0,react.useState)({});
    const [workHours, setWorkHours] = (0,react.useState)("");
    const [autoCalculate, setAutoCalculate] = (0,react.useState)(false);
    const [resetBtn, setResetBtn] = (0,react.useState)(false);
    const handleClick = ()=>{
        setResetBtn(true);
        setData({});
        setWorkHours("");
        setTimeout(()=>{
            setResetBtn(false);
        }, 1000);
    };
    const handleDataChange = (key, value)=>{
        setData({
            ...data,
            [key]: value
        });
    };
    const calculateTotalWorkHours = (0,react.useCallback)(()=>{
        let totalMinutes = 0;
        Object.values(data).forEach((value)=>{
            const [hours, minutes] = value.split(":").map(Number);
            totalMinutes += hours * 60 + minutes;
        });
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const formattedHours = "".concat(hours, ":").concat(minutes.toString().padStart(2, "0"));
        // console.log(formattedHours)
        setWorkHours(formattedHours);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (autoCalculate) {
            calculateTotalWorkHours();
        }
    }, [
        autoCalculate,
        calculateTotalWorkHours
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full lg:w-[586px] h-fit bg-white drop-shadow-xl rounded-xl pt-[25px] mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between w-[100%] px-[25px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-[23px] font-medium leading-[25px] w-[80%] md:w-[60%]",
                        children: "Calculate the hours you are owed."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "reset",
                        onClick: handleClick,
                        className: "text-red-500 w-[100px] text-[15px] font-medium flex items-center gap-[5px] ml-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "https://weareindy.com/icons/clear.svg",
                                width: "15",
                                height: "15",
                                alt: ""
                            }),
                            " Clear all"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[1px] bg-gray-300 my-[20px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[2px] justify-between items-center px-[10px] sm:px-[25px] pb-[25px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between text-[13px] font-medium text-gray-700 w-full border-b-[1px] pb-[10px] mb-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[56px]",
                                children: "Day"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[154px]",
                                children: "Start time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[154px]",
                                children: "End time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[91px]",
                                children: "Est. break"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[67px]",
                                children: "Work time"
                            })
                        ]
                    }),
                    days.map((d)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeCardCalculator_Day, {
                            onHandleData: handleDataChange,
                            resetBtn: resetBtn,
                            day: d
                        }, d);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-end items-center gap-[20px] font-medium text-gray-800 w-full my-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-fit text-[16px]",
                                children: "Total Work Time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[67px] flex justify-center text-[16px]",
                                children: workHours !== "" ? workHours : "00:00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end items-center gap-[20px] font-medium w-full pb-[20px]",
                        children: workHours ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-green-500 flex items-center text-[14px] pr-[10px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsDot */.riV, {}),
                                "Auto Calculate"
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: ()=>{
                                calculateTotalWorkHours();
                                setAutoCalculate(true);
                            },
                            className: "bg-emerald-500 font-medium text-[18px] py-[12px] px-[80px] text-white rounded-[40px]",
                            children: "Calculate"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TimeCardCalculator_TimeCalc = (TimeCalc);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/work-hours-calculator/index.jsx




const BlogData = [
    {
        id: 1,
        question: "What is Work Hours Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "",
                children: [
                    "A work hours calculator is a simple tool to work out how many hours someone worked over a period of time. This includes break time or time off during the period.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "The work hours calculator takes the total time between the starting and ending time and then deducts times when the employee is not working, such as a lunch break or driver rest time. The timesheet calculator can work out hours and minutes worked to produce the total hours worked between the starting and ending times."
                ]
            })
        })
    },
    {
        id: 2,
        question: "How to calculate hours worked?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "",
                children: [
                    "To calculate the hours worked, simply enter the start and end times for each work period into our Work Hours/Time Card Calculator. The calculator will automatically calculate the total number of hours worked, including any breaks or time off taken during the work period.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "You can easily generate a comprehensive time report that details the hours worked for a particular day, week or month. With our intuitive interface, tracking work hours has never been easier."
                ]
            })
        })
    },
    {
        id: 3,
        question: "How to calculate hours worked per week?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "To calculate hours worked per week, use our Work Hours/Time Card Calculator by inputting the start and end times of each work period for the week. The calculator will automatically calculate the total hours worked, including any breaks or time off taken."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "You can then generate a weekly time report that shows the total hours worked for each day and the entire week. Our tool allows you to stay organized and track your work hours with ease."
                })
            ]
        })
    },
    {
        id: 4,
        question: "Why do I need to calculate hours worked?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-[10px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "Calculating work hours is important for several reasons. First, it helps you stay organized and keep track of the time you spend working. This information can be useful when planning your schedule, estimating project timelines, and even when requesting overtime pay."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "Additionally, employers often require accurate timekeeping for legal and payroll purposes. With our Work Hours/Time Card Calculator, you can ensure that you are keeping accurate records of your work hours."
                })
            ]
        })
    },
    {
        id: 5,
        question: "How should I use the work hours calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-[10px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "You can use the work hours calculator in several different ways. The first and most important way is to work out the number of hours you have worked. By doing this you will save a lot of time, and remove the potential for errors. It means you won’t be underpaid, and you can avoid the possibility of entering too many hours and getting into trouble at work."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "",
                    children: "The second way is to check your own calculations. While this won’t save time like the first way will, it will make sure there are no errors in your calculations. We guarantee error-free calculations as long as you enter the correct values into the correct boxes."
                })
            ]
        })
    },
    {
        id: 6,
        question: "Is the Work Hours calculator free to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[10px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, our Work Hours/Time Card Calculator is completely free to use. We believe in providing tools that can help simplify your work and improve your productivity. Our tool provides an intuitive interface and powerful functionality to help you track your work hours and generate comprehensive time reports. Plus, since it's free, you can use it without worrying about additional costs or fees."
            })
        })
    },
    {
        id: 7,
        question: "Can the Work Hours Calculator be used for remote work or flexible schedules?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[10px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Absolutely! The Work Hours Calculator can track work hours for any type of schedule, whether you work remotely, have a flexible schedule, or work traditional hours in an office setting."
            })
        })
    },
    {
        id: 8,
        question: "Can I calculate overtime hours using the Work Hours Calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[10px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Yes, you can calculate overtime hours using our tool. Simply input the employee's regular hours and hourly rate, as well as any overtime hours and their corresponding rate, and our calculator will automatically generate a report with the total earnings, including overtime pay."
            })
        })
    },
    {
        id: 9,
        question: "How can the Work Hours Calculator benefit my business?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[10px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "",
                children: "Using our free tool can benefit your business in several ways. Firstly, it simplifies your timekeeping process, saving you time and resources that can be allocated to other tasks. Secondly, it helps ensure accurate payroll and billing, reducing the risk of errors and potential legal issues. Lastly, it provides comprehensive time reports that can be used for performance evaluation, project management, and future planning."
            })
        })
    }
];
const TimeCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto w-full px-[10px] lg:px-[100px] py-[80px] flex flex-col xl:flex-row gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Work Hours Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.region",
                                content: "IN"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.position",
                                content: "22.351115;78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "ICBM",
                                content: "22.351115, 78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "author",
                                content: "BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "publisher",
                                content: "BoloSign "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: "https://www.bolosign.com/calculators/work-hours-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: "https://www.bolosign.com/calculators/work-hours-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: "Work Hours Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://bolosign.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:url",
                                content: "https://www.bolosign.com/calculators/work-hours-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[550px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[30px] w-full xl:w-[50%] text-center xl:text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                                children: [
                                    "Work Hours ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " Calculator"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-[16px] xl:text-[18px] font-light",
                                children: "Effortlessly track work hours with our work hours calculator tool. Generate comprehensive daily and weekly time reports, including break time and time off, based on work times and hourly rates. Simplify your timekeeping and maximize your productivity with our easy-to-use work hours calculator."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "xl:flex flex-col gap-[15px] w-full pr-[100px] mt-[120px] hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "font-medium text-[30px]",
                                        children: "BoloForms makes it easier"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-light",
                                        children: "Transform your time management with BoloForms Time Tracker - the ultimate tool for simplifying time tracking. With just one click, you can start tracking your time and easily pause when you need a break."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-light",
                                        children: "Say goodbye to tedious time management tasks and hello to streamlined workflows with BoloForms Time Tracker."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeCardCalculator_TimeCalc, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Facts about work hours calculators",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var work_hours_calculator = (TimeCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,9774,2888,179], function() { return __webpack_exec__(66171); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);